import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SiteSettingsContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    company_name: 'Click One MSP',
    tagline: 'Your business. Impenetrable.',
    email: 'Sales@clickonemsp.ca',
    phone: '(778) 562-6930',
    address: 'Vancouver, BC, Canada',
    logo_url: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      if (response.data) {
        const data = { ...response.data };
        // Convert relative API paths to full URL, leave frontend public paths as-is
        if (data.logo_url) {
          if (data.logo_url.startsWith('/api/uploads/')) {
            data.logo_url = `${process.env.REACT_APP_BACKEND_URL}${data.logo_url}`;
          } else if (data.logo_url.includes('/api/uploads/')) {
            const uploadPath = data.logo_url.substring(data.logo_url.indexOf('/api/uploads/'));
            data.logo_url = `${process.env.REACT_APP_BACKEND_URL}${uploadPath}`;
          }
          // Paths like /clickonemsp-logo.png are served from frontend public/ — no change needed
        }
        setSettings(data);
      }
    } catch (error) {
      console.log('Using default settings');
    } finally {
      setLoading(false);
    }
  };

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refetch: fetchSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
};
